/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fork, takeLatest } from 'redux-saga/effects';
import ActionConstants from '../constants/';
import workerSaga from './workerSaga';
import { takeLatestUntilApiCancel } from './merchantListing';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* settingsWatcher(): Generator<any, void, unknown> {
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_ACTIVE_WEBHOOK_EVENTS);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_V3_MERCHANT_WEBHOOK);
  yield takeLatest(ActionConstants.GET_MERCHENT_SETTINGS, workerSaga);
  yield takeLatest(
    ActionConstants.UPDATE_MERCHENT_GENERAL_SETTINGS,
    workerSaga
  );
  yield takeLatest(ActionConstants.UPDATE_MERCHENT_WEBHOOK, workerSaga);
  yield fork(takeLatestUntilApiCancel,ActionConstants.UPDATE_V3_MERCHANT_WEBHOOK);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_ACTIVE_USERS_LIST);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_ALL_ROLES);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_ALL_PERMISSIONS_LIST
  );
  yield takeLatest(ActionConstants.POST_CREATE_NEW_ROLE, workerSaga);
  yield takeLatest(ActionConstants.POST_UPDATE_USER_DETAILS, workerSaga);
  yield takeLatest(ActionConstants.DELETE_USER, workerSaga);
  yield takeLatest(ActionConstants.POST_CREATE_NEW_USER, workerSaga);
  yield takeLatest(ActionConstants.POST_RESEND_INVITATION, workerSaga);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_CHECKOUT_THEME);
  yield takeLatest(ActionConstants.POST_UPDATE_CHECKOUT_THEME, workerSaga);
  yield takeLatest(ActionConstants.GET_DASHBOARD_THEME, workerSaga);
  yield takeLatest(ActionConstants.POST_UPDATE_DASHBOARD_THEME, workerSaga);
  yield takeLatest(ActionConstants.PUT_UPDATE_MERCHANT_TPV_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_CASE_MANAGEMENT_AUTH_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_TICKET_LIST_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_TICKET_DETAIL_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_CATEGORY_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_SUBCATEGORY_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_CREATE_TICKET_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_UPLOAD_DOCUMENTS_ACTION, workerSaga);
  yield takeLatest(
    ActionConstants.GET_LINK_DOCUMENTS_TO_TICKETS_ACTION,
    workerSaga
  );
  yield takeLatest(ActionConstants.GET_ALL_COMMENTS_ACTION, workerSaga);
  yield takeLatest(ActionConstants.ADD_COMMENTS_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_ALL_ATTACHMENTS_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_PREVIEW_ACTION, workerSaga);
  yield takeLatest(ActionConstants.FETCH_OFFERS_RULE, workerSaga);
  yield takeLatest(ActionConstants.SET_OFFERS_RULE, workerSaga);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS,
  );
  yield takeLatest(
    ActionConstants.UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK,
    workerSaga
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.POST_UPDATE_MERCHANT_VERSION
  );
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_CHECKOUT_VERSION);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_HAS_MERCHANT_TRANSACTED);
  yield takeLatest(ActionConstants.GET_DOWNLOAD_CSR_APPLE_PAY, workerSaga);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_APPLE_PAY_WALLET_STATUS
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_APPLE_PAY_INTEGRATION_STATUS
  );
  yield takeLatest(ActionConstants.WEB_REGISTRATION_APPLE_PAY, workerSaga);
  yield takeLatest(ActionConstants.ACTIVATE_APPLE_PAY_CERTIFICATE, workerSaga);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_PAYMENT_MODES);
}
